export interface IStoreDetails {
  storePreview: string;
  storeName: string;
  storeRating: string;
  storeItemCount: number;
  storePrice: number;
  storeLocation: string;
  storeCreationDate: string;
}

const defaultPlaceholderImage = 'https://placehold.co/210x121/';

export const bestDeals: IStoreDetails[] = [
  {
    storePreview: defaultPlaceholderImage,
    storeName: "Akado Children's Wear",
    storeRating: '4.8',
    storeItemCount: 120,
    storePrice: 499,
    storeLocation: 'Nike',
    storeCreationDate: 'Joined May 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'GlowTech Gadgets',
    storeRating: '4.5',
    storeItemCount: 95,
    storePrice: 24999,
    storeLocation: 'Lekki',
    storeCreationDate: 'Joined March 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: "Nduka's Home Essentials",
    storeRating: '4.3',
    storeItemCount: 210,
    storePrice: 3999,
    storeLocation: 'Enugu',
    storeCreationDate: 'Joined January 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Naija Drip Clothing',
    storeRating: '4.7',
    storeItemCount: 160,
    storePrice: 899,
    storeLocation: 'Abuja',
    storeCreationDate: 'Joined February 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Urban Feet Sneakers',
    storeRating: '4.9',
    storeItemCount: 85,
    storePrice: 16999,
    storeLocation: 'Yaba',
    storeCreationDate: 'Joined April 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Classy Wears by Tolu',
    storeRating: '4.6',
    storeItemCount: 110,
    storePrice: 3499,
    storeLocation: 'Ikeja',
    storeCreationDate: 'Joined May 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: "Gifty's Accessories",
    storeRating: '4.4',
    storeItemCount: 140,
    storePrice: 1599,
    storeLocation: 'Nsukka',
    storeCreationDate: 'Joined June 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Elite Electronics',
    storeRating: '4.2',
    storeItemCount: 78,
    storePrice: 49999,
    storeLocation: 'Victoria Island',
    storeCreationDate: 'Joined March 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'GrubHub Market',
    storeRating: '4.0',
    storeItemCount: 300,
    storePrice: 299,
    storeLocation: 'Ajah',
    storeCreationDate: 'Joined January 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'House of Fabrics',
    storeRating: '4.5',
    storeItemCount: 180,
    storePrice: 2499,
    storeLocation: 'Onitsha',
    storeCreationDate: 'Joined February 2025',
  },
];

export const discountStores: IStoreDetails[] = [
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Budget Bazaar',
    storeRating: '4.3',
    storeItemCount: 340,
    storePrice: 199,
    storeLocation: 'Iyana Ipaja',
    storeCreationDate: 'Joined January 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Just ₦999 Deals',
    storeRating: '4.1',
    storeItemCount: 120,
    storePrice: 999,
    storeLocation: 'Ogba',
    storeCreationDate: 'Joined February 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Everyday Value Mart',
    storeRating: '4.4',
    storeItemCount: 285,
    storePrice: 499,
    storeLocation: 'Ojota',
    storeCreationDate: 'Joined March 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Sharp Price Stores',
    storeRating: '4.0',
    storeItemCount: 150,
    storePrice: 699,
    storeLocation: 'Alaba',
    storeCreationDate: 'Joined April 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'NairaSaver',
    storeRating: '4.2',
    storeItemCount: 310,
    storePrice: 299,
    storeLocation: 'Awka',
    storeCreationDate: 'Joined March 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: "Aunty Nkechi's Corner",
    storeRating: '4.5',
    storeItemCount: 95,
    storePrice: 150,
    storeLocation: 'Nsukka',
    storeCreationDate: 'Joined May 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Yellow Tag Store',
    storeRating: '4.3',
    storeItemCount: 180,
    storePrice: 799,
    storeLocation: 'Surulere',
    storeCreationDate: 'Joined February 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Odogwu Discount Depot',
    storeRating: '4.6',
    storeItemCount: 250,
    storePrice: 399,
    storeLocation: 'Aba',
    storeCreationDate: 'Joined January 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'UniPrice Plaza',
    storeRating: '4.4',
    storeItemCount: 200,
    storePrice: 899,
    storeLocation: 'Ibadan',
    storeCreationDate: 'Joined April 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'PromoPal Market',
    storeRating: '4.1',
    storeItemCount: 220,
    storePrice: 599,
    storeLocation: 'Ilorin',
    storeCreationDate: 'Joined June 2025',
  },
];

export const newlyFeatured: IStoreDetails[] = [
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Haus of Zuri',
    storeRating: '4.7',
    storeItemCount: 85,
    storePrice: 7499,
    storeLocation: 'Lekki Phase 1',
    storeCreationDate: 'Joined July 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Obioma Luxe',
    storeRating: '4.8',
    storeItemCount: 60,
    storePrice: 10999,
    storeLocation: 'Abuja',
    storeCreationDate: 'Joined July 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Smart Kitchen Pro',
    storeRating: '4.5',
    storeItemCount: 110,
    storePrice: 2899,
    storeLocation: 'Ikeja',
    storeCreationDate: 'Joined June 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Blaq Essentials',
    storeRating: '4.6',
    storeItemCount: 90,
    storePrice: 4599,
    storeLocation: 'Port Harcourt',
    storeCreationDate: 'Joined July 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Kulture Streetwear',
    storeRating: '4.4',
    storeItemCount: 75,
    storePrice: 11999,
    storeLocation: 'Yaba',
    storeCreationDate: 'Joined June 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'Artisan Finds',
    storeRating: '4.3',
    storeItemCount: 140,
    storePrice: 3499,
    storeLocation: 'Enugu',
    storeCreationDate: 'Joined July 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'GlowUp Beauty Hub',
    storeRating: '4.5',
    storeItemCount: 98,
    storePrice: 7999,
    storeLocation: 'Asaba',
    storeCreationDate: 'Joined July 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'HomeSentials',
    storeRating: '4.2',
    storeItemCount: 180,
    storePrice: 4999,
    storeLocation: 'Ibadan',
    storeCreationDate: 'Joined June 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'One Naira Books',
    storeRating: '4.1',
    storeItemCount: 200,
    storePrice: 999,
    storeLocation: 'Zaria',
    storeCreationDate: 'Joined July 2025',
  },
  {
    storePreview: defaultPlaceholderImage,
    storeName: 'The Neon Room',
    storeRating: '4.6',
    storeItemCount: 65,
    storePrice: 13499,
    storeLocation: 'Victoria Island',
    storeCreationDate: 'Joined July 2025',
  },
];

export const CategoryList = [
  'General',
  'Arts',
  'Sculpture',
  'Bags',
  'Clothes',
  'Jewelry',
  'Photography',
  'Paintings',
  'Furniture',
  'Decor',
  'Toys',
  'Accessories',
  'Footwear',
  'Stationery',
  'Homeware',
];
